module.exports = __webpack_public_path__ + "img/up.0daee92d.png";